<template>
  <el-dialog
          :title="'详情'"
          :close-on-click-modal="false"
          :visible.sync="visible"
  style="text-align: left">

       <el-table :data="contractDatils"  border style="width: 100%">


           <el-table-column prop="name" label="品名" width="100px">
           </el-table-column>
           <el-table-column prop="specification" label="规格">
           </el-table-column>
           <el-table-column prop="num" label="数量" sortable>

           </el-table-column>
           <el-table-column prop="unit" label="单位">

           </el-table-column>
           <el-table-column prop="price"  label="单价(元)" sortable>

           </el-table-column>
           <el-table-column prop="useTime" label="使用年限"  :render-header="renderHeader">

           </el-table-column>
       </el-table>
      <el-dialog
              style="text-align: left"
              title="导出"
              :visible.sync="exportVisible"
              append-to-body
      >
          <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
          <el-checkbox-group v-model="fieldList" @change="handleCheckedItemChange">
              <el-checkbox v-for="field in fields" :label="field.value" :key="field.value">{{field.name}}</el-checkbox>
          </el-checkbox-group>
          <form ref="exportForm" method="post" :action="this.$request.defaults.baseURL+'/bjba/equip/config/exportDetailListExcel?access_token='+this.$store.getters.token"  target="_blank">
              <input type="hidden" name="contractId"  :value="contractid" />
              <input type="hidden" name="fileds" value="" ref="fileds"/>
          </form>
          <span slot="footer" class="dialog-footer">
    <el-button @click="exportVisible = false">取 消</el-button>
    <el-button type="primary" @click="exportExcel">确 定</el-button>
  </span>
      </el-dialog>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import Template from "@/template";
  const exportFields=[
      {value:"name",name:"名称"},
      {value:"specification",name:"规格"},
      {value:"unit",name:"单位"},
      {value:"price",name:"单价"},
      {value:"inventory",name:"库存"},
      {value:"useTime",name:"使用年限"},
      {value:"type",name:"类型"},
      {value:"num",name:"数量"}
  ]
  export default {
      components: {Template},
      data () {

      return {
        visible: false,
        contractid: '',
        contractDatils:[],
        types:[],
        isIndeterminate:false,
        exportVisible:false,
        checkAll:false,
        fields:exportFields,
        filedValues:exportFields.map(item => item.value),
        fieldList:[]
      }
    },
    methods: {
      init (id) {

        this.contractid = id
        this.visible = true
        this.$nextTick(() => {
            this.getContarctDatils()
        })

      },
        getContarctDatils() {
            this.$http({
                url: '/bjba/equip/config/details/'+this.contractid,
                method: 'get'
            }).then(({data}) => {
                this.contractDatils = data.data
            })
        },
        handleCheckAllChange(val) {
            this.fieldList = val ? this.filedValues: [];
            this.isIndeterminate = false;
        },
        handleCheckedItemChange(value) {
            let checkedCount = value.length;
            this.checkAll = checkedCount === this.filedValues.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.fields.length;
        },
        showExportDialog() {
            this.exportVisible = true
        },
        renderHeader (h) {
            return (
                <div class="clearfix">
                    <span>使用年限</span>
                    <el-button style="padding:5px;float:right" size="mini"
                               onClick={()=>this.showExportDialog()}>导出</el-button></div>
            )
        },
        exportExcel() {

            var filedLast = this.fields.filter(filed=>{
                return this.fieldList.indexOf(filed.value) !==-1
            })
            if(filedLast && filedLast.length>0) {
                this.$refs.fileds.value = JSON.stringify(filedLast)
                this.$refs.exportForm.submit();
            } else {
                this.$message({
                    message: '请选择字段',
                    type: 'error',
                    duration: 1500
                })
                return
            }
        },
    }
  }
</script>
